import A from 'const/actionTypes'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

export default {
  clearTrackingPowerRankingCount: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_TRACKING_POWER_RANKING_COUNT, })
    }
  },
  startListeningToTrackingPowerRankingCount: () => {
    return (dispatch, getState) => {
      firebaseService.subscribe(
        'trackingPowerRankingCount',
        (result) => {
          const trackingPowerRankingCount = result.val() || 0
          dispatch({
            type: A.SET_TRACKING_POWER_RANKING_COUNT,
            trackingPowerRankingCount
          })
        },
        N.GAMERS
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/trackingPowerRankingCount.js